import { render, staticRenderFns } from "./sspoin.vue?vue&type=template&id=50b19972&"
import script from "./sspoin.vue?vue&type=script&lang=js&"
export * from "./sspoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports